import axios from "axios"
const BASE_URL = process.env.REACT_APP_API_URL

class CommonCourseApi {


    createCommonCourse(data, config) {
        return axios.post(BASE_URL + "/ps/createCommonCourse", data, config)
    }

        getCommonCourse(config) {
        return axios.get(BASE_URL + "/ps/getCommonCourse", config)
    }

    getCommonCourseById(id, config) {
        return axios.get(BASE_URL + `/ps/commonCourse/${id}`, config)
    }
    updateCommonCourse(id, data, config) {
        return axios.put(BASE_URL + `/ps/updateCommonCourse/${id}`, data, config)
    }
    updateCommonCourseStatus( data, config) {
        return axios.put(BASE_URL + `/ps/updateCommonCourseStatus`, data, config)
    }
    deleteCommonCourse(id, config) {
        return axios.delete(BASE_URL + `/ps/deleteCommonCourse/${id}`, config)
    }
    

}

export default new CommonCourseApi()
